// extracted by mini-css-extract-plugin
export default {"finishSetup":"_6rc67k","header":"_1b2ry13","appCard":"_chavmf","column":"_18v95n4","addToSite":"_184xay1","manageAppsLink":"_1ivu16z"};